export enum QUERY_KEYS {
  getCompanyChannels = 'company-club-channels-by-id',
  getCompanyClub = 'company-club-by-id',
}
